export { useSignIn, useSignUp } from '@clerk/react/legacy';
